export {
  genericSelectors as categoriesGenericSelectors,
  selectors as categoriesSelectors,
  actions as categoriesActions,
  reducer as categoriesReducer
} from './categoriesSlice'
export type { CategoriesState } from './categoriesSlice'
